import determineOpeningInterval from 'bl/scheduler/determineOpeningInterval.bl';
import { combineDateTimeZoneZulu } from 'utils/date/combine.util';
import timeDiffMinutes from 'utils/date/timeDiffMinutes.util';
import { isTimeBeforeOrEqual } from 'utils/predicates/time/compare.util';

const MUL = 25;
const DIV = 15;
const OFF = 6;

const partDayPixels = (minutes) => (MUL * minutes) / DIV - OFF;
const wholeDayPixels = (minutes) => (MUL * minutes) / DIV;

const calculateBlockHeight = (options) => {
  const { bgn, end, first, last, hours, tz } = options ?? {};

  // no useful data given, so return with what you can
  if (!bgn || !end) return partDayPixels(timeDiffMinutes({ bgn, end: last }) || 0);
  if (!hours) return partDayPixels(timeDiffMinutes({ bgn, end: last }) || 0);

  const { open, close } = determineOpeningInterval({ hours, bgn, end });

  // special case: an all day, cap to first and last
  const bgnDayOpen = combineDateTimeZoneZulu(bgn, open, tz);
  const bgnDayClose = combineDateTimeZoneZulu(bgn, close, tz);
  const isAllDay = isTimeBeforeOrEqual(bgn, bgnDayOpen) && isTimeBeforeOrEqual(bgnDayClose, end);
  if (isAllDay) return wholeDayPixels(timeDiffMinutes({ bgn: first, end: last }));

  // special case: the beginning is before opening hour, but end is before closing hour
  const endDayClose = combineDateTimeZoneZulu(end, close, tz);
  const isBeforeOpen = isTimeBeforeOrEqual(bgn, first) && isTimeBeforeOrEqual(end, endDayClose);
  if (isBeforeOpen) return partDayPixels(timeDiffMinutes({ bgn: first, end }));

  return partDayPixels(timeDiffMinutes({ bgn, end }));
};

export default calculateBlockHeight;
